import { css } from 'styled-components'

export const CommandInputGroup = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
`
